import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommunityUploadUrlService } from '../services/community-upload-url.service';
import { deferCommunityVideoEmbeds } from '../components/community-video-embed/community-video-embed';

/**
 * Renders a thread/post body for `[innerHTML]`: rewrites `<img>` sources that
 * point at an uploaded attachment into the form an `<img>` can actually load
 * (see CommunityUploadUrlService — the same conversion the editor uses), then
 * marks the result trusted. The body was already sanitized by the backend.
 *
 * Every video `<iframe>` is replaced by an inert two-click placeholder
 * (`deferCommunityVideoEmbeds`, decision P9): put `appCommunityVideoEmbeds` on
 * the same element so the placeholder is labelled and loads on click.
 */
@Pipe({ name: 'communityBody', standalone: true })
export class CommunityBodyPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);
  private uploadUrls = inject(CommunityUploadUrlService);

  transform(html: string | null | undefined): SafeHtml {
    if (!html) return '';
    return this.sanitizer.bypassSecurityTrustHtml(deferCommunityVideoEmbeds(this.uploadUrls.htmlToDisplay(html)));
  }
}
